var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      attrs: { color: "warning", timeout: 6000, bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function ({ attrs }) {
            return [
              _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { text: "" },
                    on: {
                      click: function ($event) {
                        _vm.showSnackbar = false
                      },
                    },
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                [_vm._v("Fechar")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showSnackbar,
        callback: function ($$v) {
          _vm.showSnackbar = $$v
        },
        expression: "showSnackbar",
      },
    },
    [_vm._v(" Este menu está temporariamente indisponível. ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }